import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccessBackoffice } from "../utils/permissions";

export default function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="grid min-h-screen place-items-center bg-ink text-barberGold">CARGANDO GERARD BARBER CLUB…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={canAccessBackoffice(user.rol) ? "/backoffice" : "/pos"} replace />;
}
